<template>
    <div v-if="hasPendingApproval">
        <div class="approval-alert shadow-sm" role="alert">
            <div v-if="isApprover">
                There are some pending updates that require your approval.<br>
                Please click on "<a href="#view-updates" data-toggle="modal">View</a>" to see the updates.
            </div>
            <div v-else>
                There are some pending updates that require approval.
            </div>
        </div>

        
    </div>
</template>

<style scoped>
	.approval-alert {
		color: #856404;
		background-color: #fff3cd;
		border-color: #ffeeba;
		position: relative;
		padding: 0.75rem 1.25rem;
		margin-bottom: 1rem;
		border: 1px solid transparent;
		border-radius: 0.25rem;
	}

	.approval-alert a {
		color: #856404;
		font-weight: bold;
	}
</style>

<script>
	export default {
		data() {
			return {};
		},
		computed: {
			isApprover: function() {
				return this.$store.getters.company.designation === "approver";
			}
		},
		props: ["hasPendingApproval"]
	};
</script>